import { apiGet, apiPatch } from './client';
import type {
  CurrencyNonSettlementDate,
  CurrencyNonSettlementDateBatchRequest,
} from '../types/CurrencyNonSettlementDate';

export function getCurrencyNonSettlementDates(): Promise<
  CurrencyNonSettlementDate[]
> {
  return apiGet<CurrencyNonSettlementDate[]>(
    '/api/currency-non-settlement-dates',
  );
}

export function saveCurrencyNonSettlementDatesBatch(
  added: CurrencyNonSettlementDate[],
  modified: CurrencyNonSettlementDate[],
  deletedIds: number[],
): Promise<CurrencyNonSettlementDate[]> {
  return apiPatch<
    CurrencyNonSettlementDateBatchRequest,
    CurrencyNonSettlementDate[]
  >('/api/currency-non-settlement-dates/batch', {
    added,
    modified,
    deleted: deletedIds,
  });
}
